<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
	<g clip-path="url(#clip0_1185_10)">
	<path fill-rule="evenodd" clip-rule="evenodd" d="M2.93126 12.1308C1.9261 12.1308 1.63559 10.7247 2.55465 10.308L20 2.49992C21 1.99995 22 3 21.5 4L13.8527 21.4417C13.4379 22.3727 12.0765 22.0698 12.0765 21.0465L10 14L2.93126 12.1308Z" fill="currentColor"/>
	</g>
	<defs>
	<clipPath id="clip0_1185_10">
	<rect width="24" height="24" fill="white"/>
	</clipPath>
	</defs>
	</svg>
	